var map = {
	"./icons/activity-logs.svg": 54236,
	"./icons/admin.svg": 57712,
	"./icons/backup-now.svg": 53462,
	"./icons/box-rounded-gray.svg": 20522,
	"./icons/calender-icon.svg": 64001,
	"./icons/close-icon.svg": 36801,
	"./icons/delete-icon.svg": 74940,
	"./icons/download.svg": 76887,
	"./icons/dropbox-rounded-gray.svg": 96549,
	"./icons/edit.svg": 12479,
	"./icons/googleworkspace-logo-rounded-gray.svg": 35185,
	"./icons/microsoft-rounded-gray.svg": 27275,
	"./icons/overview.svg": 60850,
	"./icons/recovery-menu.svg": 68542,
	"./icons/recovery.svg": 25006,
	"./icons/refresh.svg": 71168,
	"./icons/responsive-restore-icon.svg": 6742,
	"./icons/responsive-search-icon.svg": 60652,
	"./icons/responsive-user-icon.svg": 68695,
	"./icons/search.svg": 25991,
	"./icons/seat-management.svg": 69776,
	"./icons/users.svg": 44101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87146;